export enum VideoEnum {
  YOUTUBE = 'youtube',
  FILE = 'file',
}
